import styled, { keyframes } from "styled-components";
import { stylesGlobalDefault } from "../../global/globalStyle";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  animation: ${fadeIn} 0.8s ease-out;

  & > * {
    margin-bottom: 20px;
  }

  @media (max-width: 640px) {
    padding: 30px 20px;
  }
`;

export const LogoContainer = styled.div`
  animation: ${fadeIn} 0.6s ease-out;

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const HearingInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  margin: 0 0 20px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #f9fafb;
`;

export const HearingInfoText = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${stylesGlobalDefault.blackMenu1};
  margin: 4px 0;
  width: 100%;
  text-align: center;
`;

export const Description = styled.p`
  color: ${stylesGlobalDefault.gray};
  line-height: 1.6;
  font-size: 16px;
  margin-top: 30px;
`;

export const VerificationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
  > div {
    width: 100%;
  }
  
  .verification-container {
    width: 100%;
    margin-bottom: 15px;
    align-items: center;
    justify-content: center;
  }
  
  .verification-character {
    border-radius: 8px;
    font-size: 26px;
    text-align: center;
    align-items: center;
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
    transition: border 0.2s ease-in-out;
    color: ${stylesGlobalDefault.blackMenu1};
    margin: 0 3px;
  }
  
  .verification-character--inactive {
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
  }

  #field-0, #field-1, #field-2 {
    border: 2px solid #d1dbe3;
    background: rgb(242, 244, 245);
  }

  .verification-character--inactive {
    background-color: white !important;
  }
  
  .verification-character--selected {
    border: 2px solid ${stylesGlobalDefault.blue};
    box-shadow: 0 0 5px rgba(29, 155, 240, 0.3);
  }
  
  .verification-character--filled {
    border: 2px solid ${stylesGlobalDefault.blue};
  }
`;

export const ErrorText = styled.p`
  color: ${stylesGlobalDefault.inputsBorderFocusError};
  font-size: 14px;
  margin-top: -10px;
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Button = styled.button`
  background-color: ${stylesGlobalDefault.blue};
  color: ${stylesGlobalDefault.white};
  border: none;
  padding: 12px 36px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${stylesGlobalDefault.blueDark};
    transform: translateY(-2px);
  }

  &:disabled {
    background-color: ${stylesGlobalDefault.inactivedButton};
    cursor: not-allowed;
    transform: none;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const LanguageSelectorWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #374151;
  margin: 12px 0 24px;

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;